import gql from "graphql-tag"

const DELETE_STORE_LINK = gql`
  mutation deleteStoreLink($id: ID!) {
    deleteStoreLink(id: $id) {
      status
    }
  }
`
export default DELETE_STORE_LINK
